
import weconfig from '@/libs/config'
import weapi from  '@/libs/api.request'
export default {
  state: {
    hasGetInfo: false,
    token: weconfig.getToken(),
    userInfo:null,
    userCode:'AEYQU',
    pageNum:0,
  },
  mutations: {
      setUserCode(state, user){
          if(user){
              let strs = ["a","c","f","j","g","h","i","b","d","e"];
              let uid = user.uid;
              let code = ""
              while (uid>0){
                  let n = uid % 10
                  code+=strs[n]
                  uid = parseInt(uid/10)
              }
              state.userCode = code;
          }
      },
      setUserInfo(state, user){
          state.userInfo = user;
      },
      setToken (state, token) {
          state.token = token
          weconfig.setToken(token)
      },
      setHasGetInfo (state, status) {
          state.hasGetInfo = status
      },
  },
  getters: {
      logined(state){
          if(state.token === '' || !state.hasGetInfo){
              return false;
          }
          else{
              return true;
          }
      },
      isbind(state){
          if(state.userInfo == null || state.userInfo.phone === ''){
              return false;
          }
          else
          {
              return true;
          }
      }
  },
  actions: {
      getUserInfo ({ state, commit }) {
          return new Promise((resolve, reject) => {
              try {
                  weapi.request({
                      url: 'userinfo',
                      method: 'get',
                  }).then(res => {
                      console.log(res)
                      const data = res.data.data;
                      commit('setUserInfo',res.data.data);
                      commit('setHasGetInfo', true)
                      commit('setUserCode', res.data.data)
                      resolve(data)
                  }).catch(function (error) {
                      reject(error)
                  })
              } catch (error) {
                  reject(error)
              }
          })
      },
      payProject ({ state, commit }, {app_id, project_id}) {
          let that = this;
          return new Promise((resolve, reject) => {
              try {
                  weapi.request({
                      url: 'pay/wepay/project',
                      method: 'get',
                      params: {'app_id':app_id, 'project_id':project_id},
                  }).then(res => {
                      if(res.data.code === '200'){
                          WeixinJSBridge.invoke(
                              'getBrandWCPayRequest', {
                                  "appId": res.data.data.appId,     //公众号名称，由商户传入
                                  "timeStamp": res.data.data.timeStamp,         //时间戳，自1970年以来的秒数
                                  "nonceStr": res.data.data.nonceStr, //随机串
                                  "package": res.data.data.package,
                                  "signType": res.data.data.signType,         //微信签名方式：
                                  "paySign": res.data.data.paySign//微信签名
                              },
                              function (res) {
                                  if (res.err_msg === "get_brand_wcpay_request:ok") {
                                      resolve(res)
                                  }
                                  else {
                                      reject("支付失败！")
                                  }
                              }
                          );
                      }
                      else{
                          reject(res.data.message)
                      }
                  }).catch(function (error) {
                      reject("支付失败！")
                  })
              } catch (error) {
                  reject("支付失败！")
              }
          })
      },
      payRecharge ({ state, commit }, {app_id, recharge_id,rechargeData}) {
          return new Promise((resolve, reject) => {
              try {
                  weapi.request({
                      url: 'pay/wepay/ticket',
                      method: 'get',
                      params: {'app_id':app_id, 'recharge_id':recharge_id,"rechargeData":rechargeData},
                  }).then(res => {
                      if(res.data.code === '200'){
                          WeixinJSBridge.invoke(
                              'getBrandWCPayRequest', {
                                  "appId": res.data.data.appId,     //公众号名称，由商户传入
                                  "timeStamp": res.data.data.timeStamp,         //时间戳，自1970年以来的秒数
                                  "nonceStr": res.data.data.nonceStr, //随机串
                                  "package": res.data.data.package,
                                  "signType": res.data.data.signType,         //微信签名方式：
                                  "paySign": res.data.data.paySign//微信签名
                              },
                              function (res) {
                                  if (res.err_msg === "get_brand_wcpay_request:ok") {
                                      resolve(res)
                                  }
                                  else {
                                      reject("支付失败！")
                                  }
                              }
                          );
                      }
                      else{
                          reject(res.data.message)
                      }
                  }).catch(function (error) {
                      reject("支付失败！")
                  })
              } catch (error) {
                  reject("支付失败！")
              }
          })
      },
      //弃用
      payVip ({ state, commit }, {app_id}) {
          let that = this;
          return new Promise((resolve, reject) => {
              try {
                  weapi.request({
                      url: 'payment_vip',
                      method: 'get',
                      params: {'app_id':app_id},
                  }).then(res => {
                      if(res.data.code === '200'){
                          WeixinJSBridge.invoke(
                              'getBrandWCPayRequest', {
                                  "appId": res.data.data.appId,     //公众号名称，由商户传入
                                  "timeStamp": res.data.data.timeStamp,         //时间戳，自1970年以来的秒数
                                  "nonceStr": res.data.data.nonceStr, //随机串
                                  "package": res.data.data.package,
                                  "signType": res.data.data.signType,         //微信签名方式：
                                  "paySign": res.data.data.paySign//微信签名
                              },
                              function (res) {
                                  if (res.err_msg === "get_brand_wcpay_request:ok") {
                                      resolve(res)
                                  }
                                  else {
                                      reject("支付失败！")
                                  }
                              }
                          );
                      }
                      else{
                          reject(res.data.message)
                      }
                  }).catch(function (error) {
                      reject("支付失败！")
                  })
              } catch (error) {
                  reject("支付失败！")
              }
          })
      },
  }
}
